import Lottie from 'lottie-react';
import LottieLoading from '@/assets/LottieLoading.json';

const NoDomainData = () => {
  return (
    <div className="justify-content-center align-items-center">
      <div
        className="mb-3 text-center"
        style={{ width: '250px', margin: 'auto' }}
      >
        <Lottie animationData={LottieLoading} />
      </div>
      <div className="mt-6 fw-medium text-center">دامنه ای یافت نشد. </div>
    </div>
  );
};

export default NoDomainData;
